import * as React from 'react';
import { useFavoritesAssignWidget } from './useFavoritesAssignWidget';
import { FavoritesWidgetWrapper } from '../../components/FavoritesWidgetWrapper';

export function FavoritesAssignWidgetContainer() {
  const favoritesAssignWidget = useFavoritesAssignWidget();

  return <FavoritesWidgetWrapper>{favoritesAssignWidget}</FavoritesWidgetWrapper>;
}
